import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultMethodResource,
    MethodMutationResourceSchema,
    useMethodActions,
} from '../../../../../resource/resources/artifacts/method/methodResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { MethodContent } from './MethodContent';

export const MethodEditDialog = ({
    onClose,
    objectId,
    versionedInId,
}: {
    onClose: () => void;
    objectId: string | undefined | null;
    versionedInId: string;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const methodActions = useMethodActions();
    const methodQuery = methodActions.useGetResourceByObjectIdAndVersionedIn(objectId, versionedInId);
    const updateMethod = methodActions.useUpdateResource();
    const validation = methodActions.useValidateResource(methodQuery.data?.id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: MethodMutationResourceSchema,
        defaultValues: defaultMethodResource,
        submitHandler: async (data) => {
            await updateMethod.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: methodQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit Method'}
            resourceType={ResourceType.METHOD}
            resourceValidationResult={validation.data}
            metaDataInfo={methodQuery.data}
        >
            <QueryBaseComponent name="Method" query={methodQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <MethodContent form={form} formNames={formNames} readOnly={readOnly} id={methodQuery.data?.id} />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
